import client from './AxiosClient'

const productService = {
    filter : (params) => client.get("/orders/filter", { params }),
    updateStatus : (productId) => client.patch(`products/toggle-active/${productId}`),
    assignValidator : (orderId,userId) => client.put(`orders/assign-validator/${orderId}/${userId}`),
    getDetail : (productId) => client.get(`/products/detail?productId=${productId}`),
    cancelOrderValidation : (orderId) => client.post(`orders/validator-cancel/${orderId}`),
    updateValidatorRequestStatus : (data) => client.put(`/orders/validation-status`,data),
}

export default productService;